export { default } from "./MenuTypeDisplay";
